module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid Pager Widget */

(function(fox) {

	fox.registerWidget('Grid_Pager_Dragdealer', {

		//Widget config
		configure: function(options) {
			this.registerOptions('', {
				'handleDom.setPage': {
					event: 'click',
					callback: 'domEventHandler'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.dl = this.options.dataLayer;
			this.dl.initPagerMode();
			this.ddPage = 1;
			this.pageIndex = {};
			this.currentPageIndex = 0;
			this.pagesThreshold = Math.floor(this.options.pagesCount / 2) - 2;
			this.handleEvent(this.dl, 'loaded', fox.bind(this._applyDlChanges, this));
		},

		_applyDlChanges: function() {
			this.pagerData =  this.dl.getPagerData();
			if (this.pagerData.total < 2) {
				this.removeFromDom();
				this._indom = false;
				this._rendered = false;
			} else {
				if (!this._indom || (this.pagerData.total != this.ddTotal)) {
					this.render();
				} else {
					this.slideToPage(this.pagerData.cp);
				}
			}
		},

		slideToPage: function(page) {
			if (this.ddPage != page) {
				return this.dd.setStep(page);
			}
			var start, end, i, p, el, cel;
			start = page - this.pagesThreshold;
			if (start < 1) {
				start = 1;
			}
			end = start + this.options.pagesCount;
			if (end > this.pagerData.total) {
				end = this.pagerData.total;
			}
			fox.dom.removeClass(this.options.currentPageClass, this.pageNodes[this.currentPageIndex]);
			for (i = 0; i < this.options.pagesCount; i++) {
				el = this.pageNodes[i];
				p = i + start;
				if (p > end) {
					this.pageNodes[i].innerHTML = '';
					this.pageNodes[i].setAttribute('data-page', 0);
					this.pageIndex[i] = 0;
				} else {
					if (p == this.pagerData.cp) {
						fox.dom.addClass(this.options.currentPageClass, this.pageNodes[i]);
						this.currentPageIndex = i;
					}

					this.pageNodes[i].innerHTML = p;
					this.pageNodes[i].setAttribute('data-page', p);
					this.pageIndex[i] = p;
				}
			}
		},

		domEventHandler: function (el, alias, e) {
			if (alias == 'setPage') {
				var page = el.getAttribute('data-page');
				if (!page) {
					return;
				}
				this.dl.changePage(page);
				return;
			}
			return this.callParent('domEventHandler', arguments);
		},

		_ddAnimationCallback: function(x) {
			if (this.dd && this.dd.stepRatios) {
				this.ddPage = x ? this.dd.stepRatios.indexOf(x) : this.dl._pager.cp;
				if(!this.ddPage) this.ddPage = 1;
			};
			this.slideToPage(this.ddPage);
		},

		rendering: function() {
			if (!fox.isSet(this.pagerData) || !fox.isSet(this.pagerData.total) || (this.pagerData.total < 2)) {
				this.fragment = this.createFragment();
				return ;
			}

			this.fragment = fox.Zen(this.options.template);
			this._pagesEl = fox.dom.select(this.options.pagesContainer, this.fragment).shift();
			//TODO check _pagesEl
			this.pageFragment = fox.Zen(this.options.tpl.page).firstChild;
			for (var i = 0, l = this.options.pagesCount; i < l; i++) {
				this._pagesEl.appendChild(this.pageFragment.cloneNode(true));
			}

			this.pageNodes = fox.dom.select(this.options.page, this.fragment);
			this._pagesCountEl = [];
			if (this.options.pagesCountContainer) {
				this._pagesCountEl = fox.dom.select(this.options.pagesCountContainer, this.fragment);
			}
		},

		addedToDom: function() {
			if (!fox.isSet(this.pagerData) || !fox.isSet(this.pagerData.total) || (this.pagerData.total < 2)) {
				return ;
			}
			this.ddTotal = this.pagerData.total;
			this.dd = new Dragdealer(this.options.dragdealerContainer, {
				steps: this.pagerData.total, snap: true, animationCallback: fox.bind(this._ddAnimationCallback, this)
			});
			fox.each(this._pagesCountEl, function(pc) {pc.innerHTML = this.pagerData.total}, this);
		}

	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/grid/pager/dragdealer.js
// module id = 203
// module chunks = 0